import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {HeaderInterceptor} from './header-interceptor';
import { FormatInterceptor } from './format-interceptor';
import { RetryInterceptor } from './retry-interceptor';
import { ErrorInterceptor } from './error-interceptor';
import {SuccessInterceptor} from './success-interceptor';


export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: FormatInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
// { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
